<script lang="ts" setup>
import { watch } from 'vue'
import { useFormValidator } from '../composables/form-validator.composable'

export type LValidationResult = {
  isValid: boolean
  hasError: boolean
  isPristine: boolean
  isDirty: boolean
}

type LFormEmits = {
  submit: [event: SubmitEvent]
}

const { validationResult, validateForm } = useFormValidator()

const [model] = defineModel<LValidationResult>({ required: true })
const emit = defineEmits<LFormEmits>()

watch(
  validationResult,
  (result) => {
    model.value = result
  },
  {
    deep: true
  }
)

defineExpose({
  validationResult,
  validateForm
})
</script>
<template>
  <form @submit="emit('submit', $event as SubmitEvent)">
    <slot></slot>
  </form>
</template>
